/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { SaveDataFirstStage200ResponseData } from './SaveDataFirstStage200ResponseData'
import {
  SaveDataFirstStage200ResponseDataFromJSON,
  SaveDataFirstStage200ResponseDataFromJSONTyped,
  SaveDataFirstStage200ResponseDataToJSON,
} from './SaveDataFirstStage200ResponseData'

/**
 *
 * @export
 * @interface SaveDataFirstStage200Response
 */
export interface SaveDataFirstStage200Response {
  /**
   *
   * @type {boolean}
   * @memberof SaveDataFirstStage200Response
   */
  status: boolean
  /**
   *
   * @type {SaveDataFirstStage200ResponseData}
   * @memberof SaveDataFirstStage200Response
   */
  data: SaveDataFirstStage200ResponseData
}

/**
 * Check if a given object implements the SaveDataFirstStage200Response interface.
 */
export function instanceOfSaveDataFirstStage200Response(
  value: object
): value is SaveDataFirstStage200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function SaveDataFirstStage200ResponseFromJSON(
  json: any
): SaveDataFirstStage200Response {
  return SaveDataFirstStage200ResponseFromJSONTyped(json, false)
}

export function SaveDataFirstStage200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SaveDataFirstStage200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: SaveDataFirstStage200ResponseDataFromJSON(json['data']),
  }
}

export function SaveDataFirstStage200ResponseToJSON(
  value?: SaveDataFirstStage200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: SaveDataFirstStage200ResponseDataToJSON(value['data']),
  }
}
